/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useState, useEffect, useCallback } from 'react';
import { bindActionCreators } from 'redux';
import { get, clone, isNil } from 'lodash';
import ProtectionPlansStatic from '../../components/ProtectionPlansStatic';
import ProtectionPlansPen from '../../components/ProtectionPlansPen';
import SidebarContainer from '../SidebarContainer';
import dealersActions from '../../redux/dealers/actions';
import penActions from '../../redux/pen/actions';
import verificationsActions from '../../redux/verifications/actions';
import ErrorMessage from '../../components/ErrorMessage';
import {
  protectionPlanSteps,
  protectionPlanSource,
} from '../../util/constants';
import './ProtectionPlans.scss';

import DealerNav from '../../components/DealerNav';

function ProtectionPlans(props) {
  const { dealers, actions, history, match, pen } = props;
  const { error, fetching } = dealers;
  let { dealer } = dealers;
  const { dealerId } = match.params;
  let { page } = match.params;
  if (!page) {
    // Set Default page
    page = protectionPlanSteps.REGISTRATION;
  }

  const getProtectionPlanSource = useCallback(() => {
    const penConfigSource = get(pen, 'penConfig.protectionPlanSource');
    return !isNil(penConfigSource)
      ? penConfigSource
      : protectionPlanSource.STATIC;
  }, [pen]);

  const [pps, setPps] = useState(getProtectionPlanSource());

  useEffect(() => {
    actions.initPenConfigRequest({});
    if (!dealer.id && !fetching && dealerId) {
      actions.dealerRequest({ dealerId });
    }
  }, [actions, dealerId, fetching, dealer]);

  useEffect(() => {
    const routeToPage = () => {
      const penDealerId = get(dealer, 'penConfig.dealerId');
      if (!penDealerId && page !== protectionPlanSteps.REGISTRATION) {
        history.push(`/${dealerId}/protection-plans/registration`);
      } else if (penDealerId && page === protectionPlanSteps.REGISTRATION) {
        history.push(`/${dealerId}/protection-plans/products`);
      }
    };

    setPps(getProtectionPlanSource());
    routeToPage();
  }, [dealer, history, dealerId, page, getProtectionPlanSource, pen]);

  const isChecked = value => pps === value;

  const onSave = ({ updatedDealer }) => {
    if (updatedDealer) {
      dealer = clone(updatedDealer);
    }
    dealer.protectionPlanSource = pps;
    actions.updateDealerRequest({
      dealer,
      route: `/dealer/${dealer.id}/`,
    });
  };

  const handleProtectionPlanSourceChange = changeEvent => {
    setPps(changeEvent.target.value);
    const { penConfig } = pen;
    penConfig.protectionPlanSource = changeEvent.target.value;
    actions.setPenConfigRequest({ penConfig });
  };

  return (
    <SidebarContainer
      title={dealer.name ? dealer.name : 'Protection Plans'}
      logo={dealer.logo}
    >
      <div className="dealers-table">
        <DealerNav />
        {error && <ErrorMessage error={error} />}
        {dealer.id && (
          <div className="protection-plans-container">
            <div className="protection-plans-source-input-container">
              Protection Plan Source:
              <label>
                <input
                  type="radio"
                  name="pps"
                  value={protectionPlanSource.STATIC}
                  checked={isChecked(protectionPlanSource.STATIC)}
                  onChange={handleProtectionPlanSourceChange}
                  className="form-check-input"
                />
                Static Protection Plans
              </label>
              <label>
                <input
                  type="radio"
                  name="pps"
                  value={protectionPlanSource.PEN}
                  checked={isChecked(protectionPlanSource.PEN)}
                  onChange={handleProtectionPlanSourceChange}
                  className="form-check-input"
                />
                PEN
              </label>
            </div>
            <div>
              {pps === protectionPlanSource.STATIC && (
                <ProtectionPlansStatic
                  page={page}
                  dealer={dealer}
                  onSave={onSave}
                  history={history}
                  actions={actions}
                />
              )}
              {pps === protectionPlanSource.PEN && (
                <ProtectionPlansPen
                  page={page}
                  dealer={dealer}
                  history={history}
                  actions={actions}
                  onSave={onSave}
                  fetching={pen?.fetching || dealers?.fetching}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </SidebarContainer>
  );
}

ProtectionPlans.propTypes = {
  actions: PropTypes.object,
  dealers: PropTypes.object,
  dealer: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  pen: PropTypes.object,
};

const mapStateToProps = ({ dealers, pen }) => ({
  dealers,
  pen,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    { ...dealersActions, ...penActions, ...verificationsActions },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProtectionPlans);
